module.exports = __webpack_public_path__ + "static/media/IMG_20220414_132352_859.b690b3c3.jpg";